import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import es from '../locales/es.json';

// Map any browser locale → one of our 3 supported languages.
// Examples handled:
//   es-MX, es-419, es-ES, es     → 'es'
//   fr-CA, fr-FR, fr             → 'fr'
//   anything else (en-US, de, …) → 'en'
// Returning the SUPPORTED code stops the detector from cascading into
// an unsupported variant (and prevents 404-style fallbacks at runtime).
const convertDetectedLanguage = (lng) => {
    if (!lng || typeof lng !== 'string') return 'en';
    const code = lng.toLowerCase().split('-')[0];
    if (code === 'es') return 'es';
    if (code === 'fr') return 'fr';
    return 'en';
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            es: { translation: es }
        },
        supportedLngs: ['en', 'fr', 'es'],
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            // Order matters:
            //   1. localStorage  → respect a user's previous manual choice
            //   2. navigator     → first-visit auto-detection from browser
            //   3. htmlTag       → optional <html lang> attribute
            order: ['localStorage', 'navigator', 'htmlTag'],
            lookupLocalStorage: 'i18nextLng',
            // Only persist when the user actively switches, not on auto-detect,
            // so a user who's never picked a language can have their browser
            // preference re-evaluated if it changes (rare but harmless).
            caches: ['localStorage'],
            // Map raw browser codes → our 3 supported buckets.
            convertDetectedLanguage,
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;
